import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { showCookieConsent } from "../../../utils/cookiebot";

class CookieSettings extends Component {
  handleShowCookieSettings = () => {
    showCookieConsent();
    // Close the user dropdown if a close handler is provided
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    const { t } = this.props;

    // Only render if CBID is configured
    if (!process.env.REACT_APP_CBID) {
      return null;
    }

    return (
      <button
        className="button button--link"
        onClick={this.handleShowCookieSettings}
        title={t(
          "userProfile.navigation.tab.cookieSettings",
          "Manage Cookie Preferences",
        )}
      >
        {t("userProfile.navigation.tab.cookieSettings", "Cookie Settings")}
      </button>
    );
  }
}

export default withTranslation("common")(CookieSettings);
